import EsusView from 'components/esus/EsusView'
import React from 'react'

export default () => {
  return <EsusView url='/pec/user/relatorios/producao/analiticoResumoProducao' />
}
